import isEqual from 'lodash/isEqual';

const titleTag = document.querySelector('title');
const { dataLayer, location } = window;

export default {
  current: {
    pathname: '',
    title: '',
  },

  set({
    pathname,
    title,
  } = {}) {
    const draft = {
      path: pathname || location.pathname,
      title: title
        ? `${title} | 公民科網上閱讀獎勵計劃`
        : '公民科網上閱讀獎勵計劃',
    };

    if (isEqual(this.current, draft)) return;

    this.current = draft;

    if (titleTag) {
      titleTag.innerHTML = draft.title;
    }

    if (dataLayer) {
      dataLayer.push({
        event: 'pageview',
        pagePath: draft.pathname,
        pageTitle: draft.title,
      });
    }
  },
};
